import { useEffect, useRef, useState } from 'react';
import Styles from './FJAIToolsTab.module.less';
import FJLocalStore from '../../../../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import useLocalStore from '../../../../../../hooks/useLocalStore.js';
const FJAIToolsTab = props => {
    useLocalStore();
    const {
        currentIndex,
        tabList,
        iconMap = {},
        onChange,
        children,
        title,
        cloudDesc,
        cloudExpiredCom,
        showHeader = true,
    } = props;
    const tabRefList = useRef([]);
    const [tabWidthList, setTabWidthList] = useState([]);
    const currentTag = FJLocalStore.currentTag();

    useEffect(() => {
        setTimeout(() => {
            // 页面加载延迟后获取tab宽度
            const tempTabWidthList = tabRefList.current.map(itemRef => {
                return itemRef.getBoundingClientRect().width;
            });
            setTabWidthList(tempTabWidthList);
        }, 100);
    }, [currentTag]);

    const width = tabWidthList[currentIndex] || 0;
    let left = 0;
    tabWidthList.forEach((item, index) => {
        if (index < currentIndex) {
            left = left + (item || 0) + 48;
        }
    });

    return (
        <div className={Styles.tab_box_container}>
            {showHeader && (
                <div className={Styles.header}>
                    <div className={Styles.title}>{title || FJLocalStore._(tabList[currentIndex])}</div>
                    {cloudDesc && <div className={Styles.cloud_desc}>{cloudDesc}</div>}
                </div>
            )}
            {cloudExpiredCom}
            <div className={Styles.tab_box}>
                <ul className={Styles.tab}>
                    {tabList.map((item, index) => {
                        const icon = iconMap[item];
                        return (
                            <li
                                style={
                                    icon
                                        ? {
                                              display: 'flex',
                                              alignItems: 'center',
                                              opacity: 1,
                                              color: 'rgba(8, 10, 16, 0.6)',
                                          }
                                        : {}
                                }
                                key={item}
                                onClick={() => {
                                    onChange && onChange(index);
                                }}
                                ref={e => {
                                    tabRefList.current[index] = e;
                                }}
                                className={currentIndex === index ? Styles.active : ''}
                            >
                                {icon}
                                {FJLocalStore._(item)}
                            </li>
                        );
                    })}
                    <div className={Styles.line} style={{ left, width }} />
                </ul>
                {children}
            </div>
        </div>
    );
};

FJAIToolsTab.propTypes = {
    currentIndex: PropTypes.number.isRequired,
    tabList: PropTypes.array.isRequired,
    iconMap: PropTypes.object,
    onChange: PropTypes.func,
    children: PropTypes.node,
    title: PropTypes.string,
    cloudDesc: PropTypes.string,
    cloudExpiredCom: PropTypes.node,
    showHeader: PropTypes.bool,
};
export default FJAIToolsTab;
